import React, { useEffect, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import "leaflet/dist/leaflet.css";
import MapLocationPicker from "../maps/locationPicker";

const MapModal = ({ isOpen, onClose, location, setLocation }) => {
    const locationData = useRef({ lat: location.lat, long: location.long });
    useEffect(() => {
        locationData.current = { lat: location.lat, long: location.long }
    }, [location])

    const setLocationData = (location) => {
        locationData.current = { lat: location.lat, long: location.long }
    }

    return (
        <Transition appear show={isOpen} as={React.Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <Transition.Child
                    as={React.Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto flex items-center justify-center p-4">
                    <Dialog.Panel className="bg-white rounded-lg p-6 shadow-lg max-w-3xl w-full">
                        <Dialog.Title className="text-lg font-medium leading-6 text-primary mb-4">
                            Map View
                        </Dialog.Title>
                        <div className="relative h-96 w-full">
                            <MapLocationPicker location={locationData.current} setLocation={setLocationData} />
                        </div>
                        <div className="mt-6 flex justify-between gap-3">
                            <button
                                type="button"
                                onClick={onClose}
                                className="bg-gray-400 text-white px-4 py-2 rounded-md hover:bg-gray-500"
                            >
                                Cancel
                            </button>

                            <button
                                type="button"
                                onClick={() => { setLocation(locationData.current); onClose() }}
                                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                            >
                                Confirm
                            </button>
                        </div>
                    </Dialog.Panel>
                </div>
            </Dialog>
        </Transition>
    );
};

export default MapModal;
